import styled from 'styled-components';
import colors from '../../../theme/Colors';
import theme from 'styled-theming';
import {Field} from 'formik';

interface InputProps {
    error?: string;
}

const borderColor = theme('brand', {
    brenntag: colors.brenntag.borderColor, 
    bcd: colors.bcd.borderColor
});

export const SLabel = styled.label`
    margin-bottom: 8px;
    font-size: 13px;
    display: inline-block;
    .asterisk {
        color: #cc0033;
    }
`;

export const SInputWrapper = styled.div`
    position: relative;
    svg {
        position: absolute;
        right: 10px;
        top: 14px;
    }
`;

export const SInput = styled(Field)<InputProps>`
    ${props => props.error ? ` 
        border: 1px solid #cc0033;
        background-color: #fffafb;
    `: `
        border: 1px solid;
    `};
    border-color: ${props => !props.error && borderColor };
    padding: 12px 15px;
    font-size: 13px;
    line-height: 20px;
    width: 100%;
    box-sizing: border-box;
    &:disabled {
        background-color: #f2f2f2f2;
    }
`;

export const SErrorMessage = styled.p`
    color: #cc0033;
    font-size: 13px;
`;